import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const passwordMismatchValidator: ValidatorFn = (
  control: AbstractControl
): ValidationErrors | null => {
  const newPassword = control.get('newPassword');
  const newPasswordCheck = control.get('newPasswordCheck');

  return newPassword && newPasswordCheck && newPassword.value !== newPasswordCheck.value
    ? { passwordMismatch: true }
    : null;
};
